import { Dialog } from "@headlessui/react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/controls/FormInput";
import FormTextarea from "../../../components/controls/FormTextArea";
import CitySelector from "../../../components/dropdowns/CitySelector";

export default function EditCompanyModal({
  isOpen,
  onClose,
  company,
  onCompanyUpdated,
}) {
  const { t } = useTranslation();

  const [selectedCityId, setSelectedCityId] = useState(null);
  const [name, setName] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (isOpen && company) {
      setSelectedCityId(company.cityId);
      setName(company.name);
      setNote(company.note || "");
    }
  }, [isOpen, company]);

  const handleUpdate = async () => {
    try {
      const payload = {
        name,
        cityId: selectedCityId,
        createdBy: company.createdBy,
        assignedTo: company.assignedTo,
        note: note.trim() || null,
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Representative/CompaniesToContact/${company.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Erreur lors de la mise à jour");

      const updatedCompany = await res.json();
      onCompanyUpdated?.(updatedCompany);
      onClose();
    } catch (err) {
      alert(err.message);
    }
  };

  if (!company) return null;

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="fixed inset-0 bg-black/40 z-40" />
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl max-h-[90vh] overflow-y-auto">
          <h2 className="text-xl font-bold mb-4 text-primary">
            {t("reservation.editCompany")}
          </h2>

          <div className="mb-4">
            <CitySelector value={selectedCityId} onChange={setSelectedCityId} />
          </div>

          <FormInput
            name="name"
            label={t("reservation.companyName")}
            value={name}
            onChange={(name, value) => setName(value)}
            required
          />

          <div className="mb-4">
            <FormTextarea
              value={note}
              label={t("global.note")}
              name="note"
              onChange={(name, value) => setNote(value)}
              placeholder={"Ex: # Téléphone, Email, Adresse, lien Facebook..."}
              rows={3}
              maxLength={500}
              showMaxLength
              required
            />
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button onClick={onClose} className="btn btn-ghost">
              {t("global.cancel")}
            </button>
            <button
              onClick={handleUpdate}
              className="btn bg-primary text-white rounded-full"
            >
              {t("global.save")}
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
